<template>
    <Layout>
      <PageHeader :title="title" :items="items"></PageHeader>
      <div class="row" id="series">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center mb-4">
                <div class="col-md-6">
                  <div class="form-inline navbar-search">
                    <div class="input-group">
                      <input v-on:keyup="search" name="title" class="form-control bg-light border-0 small"
                        placeholder="Search Title" aria-label="Search" aria-describedby="basic-addon2" value=""
                        v-model="filter" />
                      <div class="input-group-append">
                        <button class="btn btn-search" @click="searchFor">
                          <i class="fas fa-search fa-sm"> </i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="all-tabs">
                    <div class="d-flex align-items-center">
                      <span style="white-space: nowrap" class="mr-2"
                        >Filter Active User:</span
                      >
                      <b-form-select
                        id="verified"
                        style="width: 90%"
                        size="sm"
                        v-model="selected_plans"
                        value-field="plan_id"
                        text-field="name"
                        @change="fetchData(selected_plans)"
                        :options="filter_plan_options"
                      >
                      </b-form-select>
                    </div>
                    <template v-if="can('member-map-ai-tools')">
                      |
                      <div class="d-flex align-items-center">
                        <svg class="svg-inline--fa fa-table mx-2" height="16px" width="16px" aria-hidden="true"
                          focusable="false" data-prefix="fa" data-icon="table" role="img"
                          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="">
                          <path fill="currentColor"
                            d="M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z">
                          </path>
                        </svg>
                        <span class="opt" @click="showInput = !showInput">Add Member</span>

                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div v-if="showInput" class="row col-12">
                <button
                  class="btn btn-sm btn-danger position-absolute"
                  style="top: 0; right: 115px; z-index: 10; height: 38px;"
                  @click="closeMemberForm"
                >
                  ✕
                </button>
                <div class="input-group col-5">
                  <multiselect
                          @search-change="fetchMemberList"
                          id="member"
                          v-model="member_tagging"
                          :options="memberList"
                          :multiple="false"
                          track-by="member_id"
                          label="fnameAndLname"
                          placeholder="Type here to search"
                        >
                          <span slot="noOptions"> Type here to search </span>
                        </multiselect>
                </div>
                <div class="input-group col-5">
                  <multiselect
                          @search-change="fetchAiToolsList"
                          id="services"
                          v-model="ai_services"
                          :options="aiServiceList"
                          :multiple="true"
                          track-by="id"
                          label="title"
                          placeholder="Type here to search"
                        >
                          <span slot="noOptions"> Type here to search </span>
                        </multiselect>
                </div>
                <div class="col-2"><button class="btn btn-primary" @click="submitMemberMapping">Add Member</button></div>
              </div>
              <div class="table-responsive mb-0">
                <b-table striped bordered :items="tableData.data" :fields="fields" :sort-by.sync="sortBy" :per-page="0"
                  :current-page="currentPage" :sort-desc.sync="sortDesc" :filter-included-fields="filterOn"
                  @filtered="onFiltered" responsive="sm" class="table-bordered table-hover" :key="key">
                  <template v-can="'ai-tokens'" v-slot:cell(tokens)="row">
                    <div>
                      <!-- Editing mode -->
                      <div v-if="editedRowId === row.item.id">
                        <div class="input-group" style="max-width: 200px;">
                          <input
                            type="number"
                            v-model.number="addTokens"
                            placeholder="Add tokens"
                            class="form-control"
                          />
                          <input
                            type="number"
                            :value="existingTokens + addTokens"
                            readonly
                            class="form-control"
                          />
                          <button class="btn btn-success" @click="saveTokens(row.item.id)">Save</button>
                        </div>
                      </div>

                      <!-- View mode -->
                      <!-- <div v-else @click="enableTokenEdit(row.item)" style="cursor: pointer;">
                        <p class="hover-blue" title="click to Add tokens">{{ row.item.tokens }}</p>
                      </div> -->
                      <!-- <div v-else @click="enableTokenEdit(row.item)">
                        <p class="token-value sparkle">🪙 {{ row.item.tokens }}</p>
                        <button class="btn btn-success" @click.stop="enableTokenEdit(row.item)">
                          + Add Tokens
                        </button>
                      </div> -->
                      <div v-else class="token-box">
                        <p class="token-value">
                          <span class="coin">🪙</span>
                          {{ row.item.tokens }}
                        </p>

                        <button class="token-add-btn" @click.stop="enableTokenEdit(row.item)">
                          [+]
                        </button>
                      </div>
                    </div>
                  </template>
                  <template v-can="'ai-tools-members-services'" v-slot:cell(show_details)="row">
                      <b-button @click="fetchTooldetails(row.item)" variant="outline-primary" class="btn-sm m-1">Show Details</b-button>
                  </template>
                  <template v-slot:cell(transaction)="row">
                    <div>
                      <router-link :to="{
                                 name: 'ai-tools-members-transaction',
                                 params: { id: row.item.id },}">
                                 <b-button variant="outline-primary" class="btn-sm m-1">Show Transaction</b-button>
                                 </router-link>
                    </div>
                  </template>
                </b-table>
              </div>
              <template v-if="tableData.total_pages > 1">
                <div class="data_paginate">
                  <div class="dataTables_paginate paging_simple_numbers d-flex justify-content-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" first-number last-number :total-rows="tableData.total"
                        :total-pages="tableData.total_pages" :per-page="tableData.per_page"></b-pagination>
                    </ul>
                  </div>
                  <div class="form-inline navbar-search">
                    <span class="mr-2">Go to a Particular Paginated Page :</span>
                    <div class="input-group">
                      <b-form-input id="case" v-model="pageNo" placeholder="Enter Page No" class="in-width">
                      </b-form-input>
                      <div class="input-group-append">
                        <button class="btn btn-search" @click="filterPage">
                          <i class="fas fa-search fa-sm"> </i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </template>
  
  <script>
  import Layout from "../../../layouts/main";
  import PageHeader from "@/components/page-header";
  import MixinRequest from "../../../../mixins/request";
  import postsMixin from "../../../../mixins/ModuleJs/ai-tools-members";
  import Multiselect from "vue-multiselect";
  
  export default {
    data() {
      return {
        title: "List AI Tools Members",
        showInput: false,
        items: [
          {
            text: "Home",
            href: "/",
          },
          {
            text: "List",
          },
        ],
      };
    },
    mixins: [postsMixin, MixinRequest],
    components: {
      Layout,
      PageHeader,
      Multiselect,
    },
  };
  </script>

<style scoped>
/* .hover-blue {
  transition: color 0.2s ease;
}
.hover-blue:hover {
  font-weight: 900;
  color: #007bff;
} */
/* .token-hover {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.token-value {
  margin: 0;
  transition: opacity 0.2s ease;
}

.token-action {
  position: absolute;
  left: 0;
  top: 0;
  color: #007bff;
  font-size: 13px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.token-hover:hover .token-value {
  opacity: 0;
}

.token-hover:hover .token-action {
  opacity: 1;
} */

.token-box{
  display: flex;
  align-items: center;
  gap: 8px;
}

.token-value{
  margin: 0;
  font-weight: 900;
  color: #d4af37; /* gold color */
  font-size: 16px;
  display: flex;
  align-items: center;
}

.coin{
  font-size: 18px;
  margin-right: 5px;
  animation: coinGlow 2s infinite alternate;
}

/* Golden glow animation */
@keyframes coinGlow {
  0% { transform: scale(1); filter: drop-shadow(0 0 2px gold); }
  100% { transform: scale(1.1); filter: drop-shadow(0 0 6px gold); }
}

.token-add-btn{
  border: none;
  background: #28a745;
  color: white;
  font-weight: bold;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 13px;
  cursor: pointer;
}

.token-add-btn:hover{
  background: #218838;
}
</style>
  